import { createSelector } from "reselect";
import { AppState } from "../appState";
import { ETab } from "../../constants";
import { tabPositionSelector } from "./tabSelectors";
// Base selectors
const shortageStatusMasterState = (state: AppState) =>
  state.shortageStatusMasterData;
const filterStatusMasterState = (state: AppState) => state.investigationStatusMasterData;
const myAssignmentStatusMasterState = (state: AppState) =>
  state.myAssignmentStatusMasterData;
const damageStatusMasterState = (state: AppState) =>
  state.damageStatusMasterData;
const onHandDeliveryStatusMasterState = (state: AppState) =>
  state.onHandDeliveryStatusMasterData;
const misdeliveryStatusMasterState = (state: AppState) =>
  state.misdeliveryStatusMasterData;

// Memoized selector to get investigation status based on tab position
export const investigationStatusSelector = createSelector(
  [
    tabPositionSelector,
    shortageStatusMasterState,
    filterStatusMasterState,
    myAssignmentStatusMasterState,
    damageStatusMasterState,
    onHandDeliveryStatusMasterState,
    misdeliveryStatusMasterState,
  ],
  (
    tabPosition: ETab,
    shortageStatusMaster,
    filterStatusMaster,
    myAssignmentStatusMaster,
    damageStatusMaster,
    onHandDeliveryStatusMaster, 
    misdeliveryStatusMaster
  ) => {
    const statusMasterMap = {
      [ETab.shortages]: shortageStatusMaster,
      [ETab.damages]: damageStatusMaster,
      [ETab.overages]: filterStatusMaster,
      [ETab.myAssignments]: myAssignmentStatusMaster,
      [ETab.dashboard]: myAssignmentStatusMaster,
      [ETab.onHandDelivery]: onHandDeliveryStatusMaster,
      [ETab.misdelivery]: misdeliveryStatusMaster,
    };
    
    return statusMasterMap[tabPosition as keyof typeof statusMasterMap] || [];
  }
);
